import { toast } from 'react-toastify';
import * as productActions from '../store/products/actions';
import { createDateRange } from '@repo/apg-ui';

export const checkNotices = (notices, dispatch) => {
  for (let key of Object.keys(notices)) {
    const notice = notices[key];
    if (notice.code === 2111) {
      // code=2111 - budget / set price was corrected, with "value"= NEW PRICE
      dispatch(
        productActions.setProductFilterData(notice.productUrn, {
          budget: notice.value,
        }),
      );
    } else if (notice.code === 2112 || notice.code === 1021) {
      // code=2112 - Spotlength was corrected, with "value" = NEWVALUE
      dispatch(
        productActions.setProductFilterData(notice.productUrn, {
          spotlength: notice.value,
        }),
      );
    } else if (notice.code === 2102 || notice.code === 1022) {
      // code=2102 - duration in days were corrected with "value" = NEW_COUNT_OF_DAYS
      let payload: any = { duration: notice.value };
      if (notice.data && notice.data.prices && notice.data.prices.length > 0) {
        const price = notice.data.prices[0];
        const range = createDateRange(new Date(price.startdate), notice.value, {
          toEndOfYear: false,
          fullWeeks: false,
        });

        payload = {
          ...payload,
          dateRanges: [
            {
              range: [range],
              duration: notice.value,
              startDate: range.startDate,
              endDate: range.endDate,
            },
          ],
        };
      }
      dispatch(productActions.setProductFilterData(notice.productUrn, payload));
    } else if (notice.code === 2101) {
      // code=2101 - day was set to a monday (strictly speaking to a special day of the week,
      // but only monday is currently possible) "value" = 1 (day of the week with starting 1=monday
      const newStartDate = new Date(notice.startDate);
      newStartDate.setDate(notice.startDate.getDate() - notice.value);
      dispatch(
        productActions.setProductFilterData(notice.productUrn, {
          startDate: newStartDate,
        }),
      );
    }
    toast.error(notice.message);
  }
};
